// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2944":"1473a054","5367":"0d84e20c","6150":"a344b069","7867":"8256ad49"}[chunkId] + ".css";
};